import React from 'react';
import MDTypography from 'components/MDTypography';
import { ListItemWrap, StatusDot } from '../../dashboardStyled';
import { cardListColors } from 'layouts/dashboards/analytics/DashboardUtils';

const DashboardLocations = (props) => {
  const { myProfile } = props;
  const locations = myProfile?.user?.assignedLocations;

  if (!locations || locations?.length === 0) {
    return null;
  }

  return (
    <>
      {locations?.map((item, index) => {
        const { val } = item;
        const dotColor = cardListColors[index % cardListColors.length];
        return (
          <ListItemWrap key={index}>
            <StatusDot bgcolor={dotColor} />
            <MDTypography variant="button" color="text">
              {val}
            </MDTypography>
          </ListItemWrap>
        );
      })}
    </>
  );
};

export default DashboardLocations;

